import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import Link from "next/link";

const GayPrideArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/gay-pride`;

  return (
    <MainLayout>
      <NextSeo
        title='6 Best Gay Prides Around The World | DAYMADE'
        description='To celebrate Pride month, we have selected some of the most epic Gay Prides around the world so you can combine your next holiday with all the parade festivities!'
        openGraph={{
          title: '6 Best Gay Prides Around The World | DAYMADE',
          description: 'To celebrate Pride month, we have selected some of the most epic Gay Prides around the world so you can combine your next holiday with all the parade festivities!',
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/6-best-gay-prides-around-the-world',
          images: [{
            url: `${IMAGE_DIRECTORY}/hero.jpg`,
            alt: 'dozens of young people celebrating Gay Pride with rainbow flags and colourful clothes'
          }]
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'gay,pride,rights,worldwide,things to do,fun,at home,tel aviv,new york,win,sao paulo,reykjavik,amsterdam,london,festival,summer,travel,LGBTQ'
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText='dozens of young people celebrating Gay Pride with rainbow flags and colourful clothes'
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            6 best <strong>gay prides</strong> around the world
          </h1>

          <div className='separator' style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className='bigFirstLetter'>T</span>his month marks the 50th annual Pride month, celebrating the LGBTQ+ community. Unfortunately, as lockdown restrictions are still in full force, it looks like we'll have to skip a year. To celebrate Pride month, we have selected some of the most epic Gay Prides around the world so you can combine your next holiday with all the parade festivities!
          </p>

          <h4>
            TEL <strong>AVIV</strong>
          </h4>

          <p>
            Tel Aviv is a true hot spot for gay travellers and so it isn't a surprise that it hosts the largest Pride in Asia, attracting 250,000 attendees. The gay nightlife in Tel Aviv is renowned as one of the best in the world and gets even bigger and better during Pride. Many travel companies offer Pride packages to tourists visiting the Tel Aviv Pride - guaranteeing you of the best experience. Locals and visitors alike don't hold back at the Pride, so expect a wild party in the Mediterranean sun!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
            alt='couple cooking together in their home kichen'
            className='singleBlogImage'
          />

          <h4>
            NEW <strong>YORK</strong>
          </h4>

          <p>
            The city that never sleeps AND where it all started! 51 years ago kickstarted the gay liberation movement with the Stonewall riots, where trans women, drag queens and queer kids fought for their rights and freedom. A year later, the first Pride March was held, followed by a candlelight vigil in Sheridan square. Every year since, there are a series of parties and celebrations which take place throughout NYC, and continue right up until the concluding Pride Parade, which happens towards the end of June. While the main parade usually happens in the heart of Manhattan, pride events often occur in Brooklyn and Staten Island.
          </p>

          <p>
            {''}
            <Link href='/enter?utm_source=blog-article'>
              <a style={{ margin: 0, fontWeight: 'bold' }}>
                Win a trip
              </a>
            </Link>
            {''} to NYC with DAYMADE!
          </p>

          <h4>
            SAO <strong>PAULO</strong>
          </h4>

          <p>
            The Sao Paulo Gay Pride is considered the biggest and best gay pride parade in the world - it even holds the title “largest pride” in the Guinness Book of World Records! The event is the second largest of the city, after the Grand Prix Formula One Brazil. And with the current political climate, a Pride seems more relevant than ever. Although officially this is a 5 day event with the parade being the highlight, the party starts 3 weeks before with everything from debates, plays, music concerts, dance performances, cultural fairs, street markets and much more.
          </p>

          <div className='doubleImageContainer'>
            <img
              src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
              alt='Art and crafts basket with scissors, needle, and lightly coloured thread'
              className='doubleBlogImage'
            />

            <img
              src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
              alt='Woman knitting some clothes with a cup of tea'
              className='doubleBlogImage'
            />
          </div>

          <h4>
            REYKJAVIK
          </h4>

          <p>
            Blue lagoons, hot springs, Northern Lights and apparently: epic yearly Pride festivities! Iceland might not be the first place in mind for a bustling LGBTQ+ scene, but Pride is serious business with a 10-day celebration with a Pride parade, so-called bubbly brunch, an official Pride party, a Drag-Súgar drag “extravaganza” and a queer literature walking tour.
          </p>

          <p>
            {''}
            <Link href='/enter?utm_source=blog-article'>
              <a style={{ margin: 0, fontWeight: 'bold' }}>
                Win a trip
              </a>
            </Link>
            {''} to Iceland with DAYMADE!
          </p>

          <h4>
            AMSTERDAM
          </h4>

          <p>
            As the first country to legalize gay marriage, The Netherlands prides itself on its history of creating a free and safe environment for the LGBTQ+ community. As such, an epic Pride party is appropriate and the Amsterdam Pride doesn't disappoint. The highlight of the Amsterdam Gay Pride is the world-famous Canal Parade, going from Amstel towards Prinsengracht. During the final weekend you can enjoy great street parties, DJ's shows and performers, all featured around Dam square.
          </p>

          <h4>
            LONDON
          </h4>

          <p>
            Luckily, you don't need to travel far to immerse yourself in a good Pride party. London is actually one of the oldest Pride events in Europe, having origins as far back as 1972. While the main parade takes place in July, the festivities that form London pride begin as early as June. These include a wide variety of events such as art exhibitions, talks on various topics, live shows, outdoor performances and spoken word events. Attracting people from all over the UK and beyond, it makes for an extremely mixed crowd of typically over 400,000 people.
          </p>

          <p>
            {''}
            <Link href='/enter?utm_source=blog-article'>
              <a style={{ margin: 0, fontWeight: 'bold' }}>
                Win things to do
              </a>
            </Link>
            {''} in London with DAYMADE!
          </p>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt='couple cooking together in their home kichen'
            className='singleBlogImage'
          />
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default GayPrideArticle;
